import { type AssetsListGroup } from '@bts-web/data-layer/server';
import { AssetType } from '../types';

/** @todo remove, as the const enum cannot be inlined: https://github.com/microsoft/TypeScript/issues/33703
 * and Babel/SWC requires isolatedModules: true */
const enum ListOfAssetGroups {
  'ListOfAssetGroups' = 'ListOfAssetGroups',
}

const makeListOfAssetGroups = (
  ...groups: AssetsListGroup[]
): ListOfAssetGroups => groups.join(',') as ListOfAssetGroups;

const AssetTypeFilters: Record<AssetType, AssetsListGroup | ListOfAssetGroups> =
  {
    [AssetType.CRYPTO]: makeListOfAssetGroups(
      'COIN',
      'TOKEN',
      'SECURITY_TOKEN',
    ),
    [AssetType.METAL]: 'METAL',
    [AssetType.STOCK]: 'STOCK',
    [AssetType.ETC]: 'ETC',
    [AssetType.ETF]: 'ETF',
    [AssetType.EQUITY_STOCK]: 'EQUITY_STOCK',
    [AssetType.EQUITY_ETF]: 'EQUITY_ETF',
    [AssetType.EQUITY_ETC]: 'EQUITY_ETC',
    [AssetType.EQUITY_COMPLEX_ETF]: 'EQUITY_COMPLEX_ETF',
    [AssetType.EQUITY_COMPLEX_ETC]: 'EQUITY_COMPLEX_ETC',
  };

export { AssetTypeFilters };
